import { produce } from "immer";
import {
  DRAFT_DOCUMENT,
  DRAFT_DOCUMENT_SUCCESS,
  DRAFT_DOCUMENT_FAILURE,
  CLEAR_DOCUMENT_DRAFT,
} from "./constants";

export const initialState = {
  isDrafting: false,
  lastDraft: null,
  lastError: null,
};

const DocumentDraftReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case DRAFT_DOCUMENT:
        draft.isDrafting = true;
        draft.lastError = null;
        break;
      case DRAFT_DOCUMENT_SUCCESS:
        draft.isDrafting = false;
        draft.lastDraft = action.payload ?? null;
        break;
      case DRAFT_DOCUMENT_FAILURE:
        draft.isDrafting = false;
        draft.lastError = action.payload ?? true;
        break;
      case CLEAR_DOCUMENT_DRAFT:
        draft.lastDraft = null;
        draft.lastError = null;
        break;
      default:
        return state;
    }
  });

export default DocumentDraftReducer;
